module.exports = __webpack_public_path__ + "images/unit-icons/new/5x5.svg";